import { Card } from "@/components/ui/card";

export default function PaymentPage() {
  return (
    <div className="container mx-auto p-4">
      <Card className="p-6">
        <h1>Payment Page</h1>
        <p>Payment functionality coming soon...</p>
      </Card>
    </div>
  );
}

// blank template to stop errors